import { createSignal } from 'solid-js'

/**
 * The QR onboarding SESSION (PM decision 2026-09-17): the shortened landing, connect
 * and wizard apply only to the visit that arrived through the QR link — set when
 * `/join?source=qr` is handled, cleared when the shortened wizard ends, when the host
 * leaves the shortened path (Exit on the connect page, arriving on Your Listings, the
 * landing page's secondary exits), on logout, when the API refuses a code-free connect,
 * and when the API accepts one WITHOUT granting the shortcut (the listing comes back
 * unstamped) — so a later listing added from Your Listings gets the full process even
 * for a QR-marked host. The flag only asks for the shortcut; the listing record says
 * whether it was granted. Per-tab (`sessionStorage`), best-effort: no storage means no
 * shortened flow. Backed by a signal so a surface that is already mounted reacts when
 * the session ends mid-page — cross-route reactive state, hence a store. Kept
 * dependency-free so the session service can import it.
 */
export const QR_SESSION_STORAGE_KEY = 'lodgr_qr_onboarding_session'

const readStoredFlag = () => {
    try {
        return sessionStorage.getItem(QR_SESSION_STORAGE_KEY) === '1'
    } catch {
        return false
    }
}

const [
    sessionFlag,
    setSessionFlag,
] = createSignal(readStoredFlag())

export const markQrOnboardingSession = () => {
    try {
        sessionStorage.setItem(QR_SESSION_STORAGE_KEY, '1')
        setSessionFlag(true)
    } catch {
        // no storage (privacy mode, prerender): the host simply gets the full flow
    }
}

export const clearQrOnboardingSession = () => {
    try {
        sessionStorage.removeItem(QR_SESSION_STORAGE_KEY)
    } catch {
        // nothing stored
    }
    setSessionFlag(false)
}

/** Reactive: true only while the tab is in the QR onboarding session. */
export const isQrOnboardingSession = () => sessionFlag()
